// openLivestreamPopOutChat.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import { LIVESTREAM_PATH } from '../resource/liveStreamConstants.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';

let windowObject = null;

/**
 * Open livestream pop out window chat
 * @kind action
 * @param {string} {streamId} - streamId
 * @return {Promise} Action promise.
 */
const openLivestreamPopOutChat =
  ({ streamId = '' } = {}) =>
  async (dispatch, getState) => {
    if (!streamId) {
      return dispatch({ type: '' });
    }

    const isLiveStreaming = getLiveStreamData(
      getState(),
      [streamId],
      'isLiveStreaming'
    );
    if (!isLiveStreaming) {
      return dispatch({ type: '' });
    }

    if (windowObject && !windowObject.closed) {
      windowObject.close();
      windowObject = null;
    }

    windowObject = window.open(
      `/user/${streamId}/${LIVESTREAM_PATH}/chat`,
      'livestreamPopOutChat',
      'width=600,height=600'
    );

    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['liveStream'],
        data: {
          popOutStreamId: streamId,
        },
      },
    });
  };

export default openLivestreamPopOutChat;
